import { APICall } from ".."

const ControllerName = "MobPatientMedicalFiles"

export const GetLoadMedicalFiles = (patientId: number,  hospitalId: number) => {
    return APICall("get", `${ControllerName}/LoadMedicalFiles?patientId=${patientId}&hospitalId=${hospitalId}`)
}
